import { addQueryArgs } from '@wordpress/url';

// eslint-disable-next-line no-async-promise-executor
export const runRequestREST = async ( {incrementPageRequest, hasNextPage, page, selectedFilters, searchInputValue, resultsPerPage}, getFilterText ) => {
	
	// Determine which page to request
	const pageToRequest = incrementPageRequest && hasNextPage ? page + 1 : 1;

	// Request arguments
	const requestArgs = {
		keyword: searchInputValue,
		per_page: resultsPerPage,
		page: pageToRequest,
		fields: ['title', 'type', 'date', 'thumbnail_image', 'slug', 'link_type', 'link', 'meta'].join( ',' ),
		meta_fields: ['accreditation', 'title_1', 'title_2', 'location_names', 'locations'].join( ',' ),
	};

	// Build filters and add to request arguments
	const filtersArray = [];
	// Convert slugs to post title format used by ES
	selectedFilters.forEach( item => {
		filtersArray.push( 
			Array.isArray( item )
				? item.map( 
					value => {
						const formattedValue = getFilterText( value, false );
						return formattedValue.replace( /&/g, '&amp;' );
					}
				) : [] 
		);
	} );
	if ( 0 < filtersArray[0].length ) requestArgs.locations = filtersArray[0].join( ',' );
	if ( 0 < filtersArray[1].length ) requestArgs.project_types = filtersArray[1].join( ',' );
	if ( 0 < filtersArray[2].length ) requestArgs.services = filtersArray[2].join( ',' );
	if ( 0 < filtersArray[3].length ) requestArgs.post_types = filtersArray[3].join( ',' );

	const protocol = ( '192.168.22.22' === process.env.WP_ADMIN )
		? 'http'
		: 'https';
	const apiUrl = `://${process.env.WP_ADMIN}/wp-json/hks/v1/search/`;
	const baseUrl = `${protocol}${apiUrl}`;
	const fetchURL = addQueryArgs( baseUrl, requestArgs );

	const response = await fetch( fetchURL )
		.then( async response => {
			response = await response.json();
			console.log( 'JSON', response ); // eslint-disable-line
			if ( response.error ) throw response.error;
			return response;
		} )
		.catch( error => {
			console.error( error ); // eslint-disable-line
			return { isError: true, error: error };
		} );
	return response;
};
